import React, { Component } from 'react';
import { Title } from '../Components.js';
import { OptionSize } from './Options';
// import Fade from 'react-reveal/Fade';
import SizeChart from '../../SizeChart';
class StepSize extends Component {
	render() {
		const { options, handleSizeSelection, sizeChart, handleSizeChart } = this.props
		return (
			<div className="BoxBuilder_Size">
				{/* <Fade big delay={400}> */}
					<Title title="Pick A Size" />
				{/* </Fade> */}
				{/* <Fade big delay={500}> */}
					{options &&
						<div className="BoxBuilder_Options">
							{options.map((option, index) => <OptionSize
								{...option}
								key={`size-option-${index}`}
								handleSizeSelection={() => handleSizeSelection(option)}
							/>)}
						</div>
					}
				{/* </Fade> */}
				{/* <Fade big delay={500}> */}
					<span className="link" onClick={handleSizeChart}>Not sure? View the size chart.</span>
				{/* </Fade> */}
				{sizeChart &&
					<SizeChart handleSizeChart={handleSizeChart} />
				}
			</div>
		)
	}
}

export default StepSize;